import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoaderService } from './loader.service';
import { SHARED_WEB_ASSETS_URL } from '../app.constants';

@Injectable({
    providedIn: 'root'
})

export class LayoutService {
    public loaded$ = new BehaviorSubject(false);
    public loaded: {[key: string]: boolean} = {
        header: false,
        footer: false
    };

    constructor(
        private http: HttpClient,
        private loaderService: LoaderService
    ) {
        this.loaderService.addLoader(this);
    }

    setLoaded(name: string) {
        this.loaded[name] = true;

        const doneLoading = Object.keys(this.loaded).map(key => this.loaded[key]).every(Boolean);

        if (doneLoading) {
            this.loaderService.removeLoader(this);
            this.loaded$.next(true);
        }
    }

    getHeader(): Observable<any> {
        return this.http.get(`${SHARED_WEB_ASSETS_URL}/header`, {
            responseType: 'text'
        });
    }

    getFooter(): Observable<any> {
        return this.http.get(`${SHARED_WEB_ASSETS_URL}/footer`, {
            responseType: 'text'
        });
    }

}
